import React,{ useCallback, useEffect, useMemo } from "react";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Table from "../../components/admin/Table";
import { beatList, reset } from "../../slices/BeatSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import defaultConfig from "../../config/Config";
import { GoogleMap } from "../shoppingPartners/google-map";
import { CityByState, getAllState } from "../../slices/InitialDataSlice";
import { ToSelectOption } from "../../Utils/utils/CommanFnc";
import SelectBox from "../../components/admin/SelectBox";

export function List() {
  const [businessData, setBusinessData] = useState([]);
  const [columsData, setColumsData] = useState([]);
  const [isMapOpen, setIsMapOpen] = useState(false)
  const [latLng, setLatLng] = useState('');
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const data = useSelector((state) => state.beats)
  const loading = useSelector( (state) => state.beats.loading )
  const [searchParams, setSearchParams] = useSearchParams()
  const dispatch = useDispatch() 
  const queryString = Object.fromEntries([...searchParams.entries()])  
  const {StateList, CitiesList} = useSelector( (state) => state.initialData )
  const [serachString, setSearchString] = useState({
    searchString:queryString.searchString?queryString.searchString:''
  })
  const [defaultParams, setDefaultParams] = useState({
    pageLength:defaultConfig.defaultLimit,
    page:1
  })

  const openMap = useCallback((params = {}) => {
    if(isMapOpen){
      setIsMapOpen(false)
    }else{
      setLatLng(params?.punchInLatLong)
      setIsMapOpen(true)
    }
},[isMapOpen])

  const columns = useMemo(()=>{
    const col = [
      {
        
        name:"Beat Name",
        selector: (row) => row.name,
        sortable: true,
        center: true,
      },
      {
        
        name:"City",
        sortable: true,
        center: true,
        selector: (row) => row.cityName ,
      },
      {
        
        name:"State",
        sortable: true,
        center: true,
        selector: (row) =>  row.stateName ,
      },
      {
        
        name:"Pincode",
        sortable: true,
        center: true,
        selector: (row) =>  row.pincode ,
      },
      // {
      //   name: "Action",
      //   width:"7%",
      //   button: false,
      //   center: true,
      //   cell: (row) => (
      //     <>          
      //     <Link to={`/beat/edit/${row._id}`} className="sidebar-link" data-toggle="tab">
      //         {" "}
      //         <i className="fa fa-edit"></i>{" "}
      //       </Link>
      //     </>
      //   ),
      //   ignoreRowClick: true,
      //   allowOverflow: true,
      // }
    ]
    return col
  },[])   
  
  useEffect(()=>{
    dispatch(reset())
    if(Object.keys(queryString).length !== 0){
      const data= {...defaultParams, ...queryString}
      setDefaultParams(data) 
      setSearchString(queryString)
      if(queryString.state !== '' && typeof queryString.state !== "undefined"){
          dispatch(beatList({data: data}))
          dispatch(CityByState(queryString.state))
          
      }
    }
    dispatch(getAllState())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch]);

  useEffect( () =>{
    setColumsData(columns)
  },[columns, defaultParams])
  
  useEffect( ()=>{
    if(serachString.state && serachString.city){
      setBusinessData(data)
    }
  },[data, serachString.city, serachString.state])

  useEffect( () => {
    setStateList(ToSelectOption(StateList, { value:"_id", label:"name" }))
  }, [StateList])

  useEffect( () => {
    setCityList(ToSelectOption(CitiesList, { value: "_id", label: "name" }))
  }, [CitiesList])

  const setValue = (event) => {
    setSearchString({...serachString, searchString: event.target.value})
  }

  const searchInt = () => {
      let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page:1, ...serachString})
      setSearchParams(params)  
      setDefaultParams(params)
      console.log(serachString.state)
      if(serachString.state !== "" && typeof serachString.state !== "undefined"){
        dispatch(beatList({data:{...params}}))
      }
      
  }

  const setPaginationData = (paginationData) =>{
    const params = {...defaultParams, page:paginationData.page, pageLength:paginationData.pageLength}
    setSearchParams(params)  
    setDefaultParams(params)
  }

  const resetSearch = () =>{
    const queryPrm = {pageLength: defaultConfig.defaultLimit, page:1}
    setDefaultParams(queryPrm)
    setSearchParams(queryPrm)
    dispatch(reset())
  }

  const onStateChange = (opt) => {
    setCityList([])
    setBusinessData([]);
    setSearchString({...serachString, state: opt?.value || '',  city: ''})
    setSearchParams({...serachString, state: opt?.value || '',  city: ''})
    dispatch(CityByState(opt.value))
  }

  const onCityChange = (opt) => {
    setSearchString({...serachString, city: opt?.value || '' })
    setSearchParams({...serachString, state: opt?.value || '',  city: ''})
  }
  

//   useEffect(()=>{
//     const urlState = { gameType: params.type, page: defaultParams.page, pageLength: defaultParams.pageLength }  
//     const col = 
    
//     console.log(col)
//     setColumns(col)
// },[defaultParams.page])
  return (
    <React.Fragment>
      <div className="revenue-wrapper">
        <div className="row">
          <div className="col-lg-12">
            <div className="card table-card">
              <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-clock"></i> Beat List</h4>
              </div>
              <div className="row m-3">
                <div className="col-sm-10">
                  <div className="row">
                    <div className="col-sm-3 p-0">
                          <SelectBox
                              placeholder="Select State"
                              options={stateList}
                              isClearable={true}
                              defaultValue={''}
                              value={stateList.filter( (item) => item.value === serachString.state) }
                              onChange={(opt) => onStateChange(opt)}
                              
                          />
                    </div>
                    &nbsp;
                    <div className="col-sm-3 p-0">
                          <SelectBox
                              placeholder="Select City"
                              options={cityList}
                              defaultValue={''}
                              value={cityList.filter( (item) => item.value === serachString.city) }
                              isClearable={true}
                              onChange={(opt) => onCityChange(opt)}
                              
                          />
                    </div>
                    &nbsp;
                    <div className="col-sm-3 p-0">
                        <input
                        type="text"
                        defaultValue={serachString.searchString}
                        onChange={setValue}
                        placeholder="Search..."
                        className="form-control"
                        />
                    </div>
                    <div className="col-sm-2 p-0 ml-1">
                      <button onClick={searchInt} type="button" className="btn btn-primary btn-lg">
                        <i className="fa fa-search"></i>
                      </button>
                      &nbsp;
                      <button onClick={resetSearch} type="button" className="btn btn-primary btn-lg">
                        <i className="fa fa-undo"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-sm-2 text-right">
                  <Link
                      to={"/add-beat"}
                      className="button blue-button btn-success"
                      data-toggle="tab"
                    >
                      <i className="fas fa-tag"></i>
                      {" "}
                      Add Beat{" "}
                    </Link>
                </div>
              </div>
              <Table 
                totalCount={businessData.totalCount}
                data={businessData.beatList} 
                columns={columsData} 
                dataLoadFnc={beatList} 
                extraConfig = {defaultParams}
                loading={loading}  
                callBack={setPaginationData}
              />
            </div>
          </div>
        </div>
        {isMapOpen?<GoogleMap setLocationData={()=>{}} data={ {latLng, readOnly:true} } openMap={openMap} />:''}
      </div>
    </React.Fragment>
  );
}
